import "./MDLVision.scss";
import MDLSection from "../../ui/MDLSection/MDLSection";
import { tsxSection1 } from "./MDLVision.resources";

// must be inside display: flex context
const VisionCard = (props:{title: string; text: string}) => {
  return <div className="vision-card">
    <div>{props.title}</div>
    <div className="vision-seperator"></div>
    <div>{props.text}</div>
  </div>
}

const MDLVision = () => {
  return <div id="mdl-vision">
    <div id="vision-container">
      <VisionCard title="Indonesian" text={indonesianText}/>
      <VisionCard title="Deutsch" text={germanText}/>
      <VisionCard title="English" text={englishText}/>
    </div>
    <MDLSection title="Situation vor Ort" content={tsxSection1}></MDLSection>
  </div>;
};

export default MDLVision;

const indonesianText = "Membantu orang - orang yang berkekurangan di Indonesia, seperti anak-anak panti asuhan, anak-anak jalanan, orang-orang tua di panti jompo, dll. Bantuan diberikan sesuai kebutuhan orang-orang yang akan dibantu.";
const germanText = "Unterstützung von Bedürftigen in Indonesien wie Waisenkindern, Straßenkindern, älteren Menschen in Altersheimen usw. Die Hilfe wird entsprechend den Bedürfnissen der Menschen, die unterstützt werden sollen, bereitgestellt.";
const englishText = "Helping people in need in Indonesia, such as orphanage children, street children, old people in nursing homes, etc. Assistance is provided according to the needs of the people to be assisted.";
